// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3IGzo","ranges":"BmiRanges_ranges__1d4XU"};